import {
  IGetSystemAccessRequestResponse,
  IManageUserDetail, 
  IMySystemAccessRequestResponse,
  ISubmitSystemAccessRequestApproval
} from "interfaces/user/UserInterfaces"
import {formatUserDetailMetadata} from "../user/userFormatters";

export function formatSystemAccessRequest(roleAssignments: IManageUserDetail[], requestReason: string): any {
  return {
    RoleAssignments: formatRoleAssignments(roleAssignments),
    RequestReason: requestReason,
  }
}

export function formatSystemAccessRequestApproval(request: ISubmitSystemAccessRequestApproval): any {
  return {
    UserEmail: request.userEmail,
    SystemAccessRequestId : request.systemAccessRequestId,
    ApprovalResponse : request.approvalResponse,
    RoleAssignments: formatRoleAssignments(request.roleAssignments),
    DecisionReason: request.decisionReason ?? "",
  }
}

function formatRoleAssignments(roleAssignments: IManageUserDetail[]){
  return roleAssignments.map(ra => ({
    Role: ra.role,
    OrgGuids: ra.orgs.map(x => x.guid),
    ServiceTypeGuids: ra.serviceType.map(x => x.guid),
    EquipmentGuids: ra.equipment.map(x => x.guid),
    EpicEquipmentGuids: ra.epicEquipment.map(x => x.guid),
    GeoUnitGuids: ra.geoUnit.map(x => x.guid),
    ProductCenterGuids: ra.productCenter.map(x => x.guid),
    CountryGuids: ra.country.map(x => x.guid),
    IsTechUser: ra.isTechUser,
    IsPsdUser: ra.isPsdUser,
    IsMfgUser: ra.isMfgUser,
    IsRCEditor: ra.isRCEditor
  }))
}

export function formatMySystemAccessRequestResponse(response: any): IMySystemAccessRequestResponse[] {
  return response.Requests.map((r: any) => ({
    exists: r.Exists,
    id: r.Id,
    status: r.Status,
    requestReason: r.RequestReason,
    decisionReason: r.DecisionReason,
    createdOn: r.CreatedOn,
    modifiedOn: r.ModifiedOn,
    roles: r.Roles,
  }));
}

export function formatGetSystemAccessResponse(response: any): IGetSystemAccessRequestResponse {
  return {
    id: response.Id,
    email: response.Email,
    name: response.Name,
    requestReason: response.RequestReason ?? "",
    decisionReason: response.DecisionReason,
    requestDetail: response.RequestDetail.map((ra: any) => ({
      role: ra.Role,
      orgs: ra.Organizations.map((x: any) => formatUserDetailMetadata(x)),
      serviceType: ra.ServiceTypes.map((x: any) => formatUserDetailMetadata(x)),
      equipment: ra.Equipments.map((x: any) => formatUserDetailMetadata(x)),
      epicEquipment: ra.EpicEquipments.map((x: any) => formatUserDetailMetadata(x)),
      geoUnit: ra.GeoUnits.map((x: any) => formatUserDetailMetadata(x)),
      productCenter: ra.ProductCenters.map((x: any) => formatUserDetailMetadata(x)),
      country: ra.Countries.map((x: any) => formatUserDetailMetadata(x)),
      isTechUser: ra.IsTechUser,
      isPsdUser: ra.IsPsdUser,
      isMfgUser: ra.IsMfgUser,
      isRCEditor: ra.IsRCEditor
    }))
  }}
